import { IEntityWithStatus, EntityWithStatus } from "./EntityWithStatus";
import { IEntity } from "./Entity";
import { IApp03WorkflowUser } from "./App03WorkflowUser";
import { App03TaskTimeOptionKanban, App03TaskTimeOptionScrum, IApp03Task } from "./App03Task";
import { IApp03Portfolio } from "./App03Portfolio";
import { IEntityCustomFields } from "./EntityCustomFields";
import { WorkflowType } from "../refData/WorkflowType";
import { IApp03WorkflowStage } from "./App03WorkflowStage";
import { IApp03Project } from "./App03Project";


export interface IApp03Workflow extends IEntityWithStatus, IEntityCustomFields {
    ParentTypeID?: number;
    App03PortfolioID?: number;
    App03ProjectID?: number;
    WorkflowTypeID?: number;
    FrameworkID?: number;
    Description?: string;
    NewTaskDefaultStageID?: number;
    RefColumnID?: number;
    RefPrefix?: string;
    EpicRefPrefix?: string;
    CustomerID?: number;
    LeadOwnerID?: number;
    PPProjectID?: number;
    PPWorkStreamID?: number;
    InternalMsg?: string;
    TaskTimeOption?: string;
    DefaultPlanningStrategy?: string;
    App03TemplateID?: number;
    AssignedToDefaultUserID?: number;
    App03WorkflowUsers?: IApp03WorkflowUser[];
    App03WorkflowStages?: IApp03WorkflowStage[];
    App03Tasks?: IApp03Task[];
    App03Portfolio?: IApp03Portfolio;
    App03Project?: IApp03Project;
}

export class App03Workflow extends EntityWithStatus implements IApp03Workflow {
    public ParentTypeID = null;
    public App03PortfolioID = null;
    public App03ProjectID = null;
    public WorkflowTypeID = WorkflowType.General;
    public FrameworkID = null;
    public Description = null;
    public NewTaskDefaultStageID = null;
    public RefColumnID = 1; //default
    public RefPrefix = 'G';
    public EpicRefPrefix = 'E';
    public CustomerID = null;
    public LeadOwnerID = null;
    public PPProjectID = null;
    public PPWorkStreamID = null;
    public InternalMsg = null;
    public TaskTimeOption = null;
    public DefaultPlanningStrategy = 'Priority'; //default 1st option
    public App03TemplateID = null;
    public AssignedToDefaultUserID = null;
    public CustomFields = [];

    constructor(frameworkID: App03Frameworks) {
        super();
        this.FrameworkID = frameworkID;
        if (frameworkID === App03Frameworks.Kanban) {
            this.ParentTypeID = App03WorkflowParentTypes.Portfolio; //default
        }

        //set default TaskTimeOption
        if (frameworkID === App03Frameworks.Scrum) {
            this.TaskTimeOption = App03TaskTimeOptionScrum.UseStoryPoints;
        }
        else {
            this.TaskTimeOption = App03TaskTimeOptionKanban.RequiredInHours;
        }
    }
}

export enum App03Frameworks {
    Kanban = 1,
    Scrum = 2
}

export enum App03WorkflowParentTypes {
    Portfolio = 1,
    Project = 2
}